import { Box, Button, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { render } from '@testing-library/react';
import TrainerSelectModal from '../../../../views/crd/myworkspace/NewAdmissionRegister/TrainerMapping/TrainerSelectModal';
import AssignPopup from '../../../../views/batch/AssignPopup';

export const TrainerListingTableHead = ({ subjectEnrollId, subjectEnrollmentId, subject }) => [
  {
    field: 'sl_no',
    headerName: 'Sl No',
    width: 70,
  },
  {
    field: 'full_name',
    headerName: 'Tutor Name',
    width: 260,
  },
  {
    field: 'mob_no',
    headerName: 'Mobile No',
    width: 150,
  },

  {
    field: 'demo_class_evaluation',
    headerName: 'Demo Class Evaluation',
    width: 180,
    renderCell: (params) => {
      return params.row.demo_class_evaluation == 1 ? (
        <Icon icon="mdi:success-circle" width="24" height="24" style={{ color: 'green' }} />
      ) : (
        <Icon icon="mingcute:close-square-fill" width="24" height="24" style={{ color: 'red' }} />
      );
    },
    align: 'center',
  },
  {
    field: 'interview_status',
    headerName: 'Interview',
    width: 90,
    renderCell: (params) => {
      return params.row.interview_status == 1 ? (
        <Icon icon="mdi:success-circle" width="24" height="24" style={{ color: 'green' }} />
      ) : (
        <Icon icon="mingcute:close-square-fill" width="24" height="24" style={{ color: 'red' }} />
      );
    },
    align: 'center',
  },
  {
    field: 'ta_orientation',
    headerName: 'TA Orientation',
    width: 110,
    renderCell: (params) => {
      return params.row.ta_orientation == 1 ? (
        <Icon icon="mdi:success-circle" width="24" height="24" style={{ color: 'green' }} />
      ) : (
        <Icon icon="mingcute:close-square-fill" width="24" height="24" style={{ color: 'red' }} />
      );
    },
    align: 'center',
  },
  {
    field: 'mou_payment',
    headerName: 'MoU Payment',
    width: 110,
    renderCell: (params) => {
      return params.row.mou_payment == 1 ? (
        <Icon icon="mdi:success-circle" width="24" height="24" style={{ color: 'green' }} />
      ) : (
        <Icon icon="mingcute:close-square-fill" width="24" height="24" style={{ color: 'red' }} />
      );
    },
    align: 'center',
  },
  {
    field: 'tutorial_watched',
    headerName: 'Tutorials Watched',
    width: 140,
    renderCell: (params) => {
      return params.row.tutorial_watched == 1 ? (
        <Icon icon="mdi:success-circle" width="24" height="24" style={{ color: 'green' }} />
      ) : (
        <Icon icon="mingcute:close-square-fill" width="24" height="24" style={{ color: 'red' }} />
      );
    },
    align: 'center',
  },
  {
    field: 'placement_type',
    headerName: 'Type',
    width: 160,
    renderCell: ({ value }) => (
      <Typography color={value === 'intern' ? '#1f82a0ff' : '#3e9242ff '} fontWeight={600}>
        {value === 'intern' ? 'Intern' : 'Tutor'}
      </Typography>
    ),
  },
  {
    width: 90,
    field: 'action',
    headerName: 'Action',
    renderCell: (params) => {
      if (subjectEnrollmentId) {
        return (
          <TrainerSelectModal
            isDisable={!params?.row?.is_available}
            subjectEnrollmentId={subjectEnrollmentId}
            rowDetails={params.row}
          />
        );
      } else {
        return (
          <AssignPopup
            // disabled={params?.row?.mou_payment === 0}
            disabled={!params?.row?.is_available}
            tutorName={params.row.full_name}
            trainerID={params.row.trainer_id}
            subject={subject}
            subject_enrollment_id={subjectEnrollId}
          />
        );
      }
    },
  },
];
